import Mutations from '../../odata/mutations';

export default { ...new Mutations('documentTemplateField'), ...new Mutations('documentTemplateFields') };
